import { runDevicer } from '@Services/devicer/devicer.service';
import { EnvironmentVariables, getEnvironmentVariable } from '@Services/env/environment.service';

const deviceOptions = {
  publicKey: getEnvironmentVariable(EnvironmentVariables.VITE_APP_SOCURE),
  endpoint: 'https://device.lili.co/api/ingestion',
  userConsent: true,
  context: 'signup',
  includeCookies: false,
};
export const getDeviceId = async () => {
  const { sessionId } = await runDevicer(deviceOptions);
  return sessionId;
};
